import React from "react";
import Service_outer_card from "../../../Common_Component/Service_outer_card/Service_outer_card";
import Inquiry from "../../Inquiry/Inquiry";

function Branding() {



  const data = [
    {
      id: 1,
      title: "LOGO Designing",
      description: "A logo is more than just a visual—it’s the identity of your brand. A well-designed logo captures your brand’s essence, creates a lasting impression...",
      bgImgSrc: "/Assets/Images/Service/Services/Branding/loog.jpg",
      MainImgSrc: "/Assets/Images/Service/Services/Branding/img1.svg",
      baseLink: "/branding-services"
    },

    {
      id: 2,
      title: "Graphic Designing",
      description: "Graphic design is the art of visual storytelling, combining creativity and strategy to commu- -nicate your brand’s message effectively.",
      bgImgSrc: "/Assets/Images/Service/Services/Branding/GRAPHIC-DESIGN.png",
      MainImgSrc: "/Assets/Images/Service/Services/Branding/img2.png",
      baseLink: "/branding-services"
    },

    {
      id: 3,
      title: "Brand Design",
      description: "Brand design is about crafting a cohesive visual identity that reflects your business's values, personality, and mission.",
      bgImgSrc: "/Assets/Images/Service/Services/Branding/BRAND-DESIGN.png",
      MainImgSrc: "/Assets/Images/Service/Services/Branding/img3.png",
      baseLink: "/branding-services"
    }

  ]

  return (
    <>
      <section className="Multimedia_Advertising Branding">
        <div className="row">

          {data?.length > 0 && data?.map((item) => {
            return (
              <div className="col-xl-4 col-md-6">
                <Service_outer_card title={item?.title} baseLink={item?.baseLink} description={item?.description} bgImgSrc={item?.bgImgSrc} MainImgSrc={item?.MainImgSrc}  id={item?.id} />
              </div>
            )
          })}

          <Inquiry/>

          {/* <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div> */}
        </div>
      </section>
    </>
  );
}

export default Branding;
